import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import {
  ChangePasswordSection,
  SessionsSection,
  TwoFactorSection,
} from "../features/settings/SecuritySettings";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/settings/security")({
  component: SecurityPage,
});

function SecurityPage() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return (
    <>
      <TwoFactorSection me={me.data} />
      <ChangePasswordSection />
      <SessionsSection me={me.data} />
    </>
  );
}
